import React from "react";
import "./FinanceBlogs.scss";

const FinanceBlogs = () => {
  return (
    <div className="finance-blogs">
      <div className="finance-blogs-section1_2">
        <div className="finance-blogs-section1">NEW & BLOGS</div>
        <div className="finance-blogs-section2">
          <h1 className="finance-blogs-section2-heading">
            Read All Our Consulting<br></br> News & Blogs
          </h1>
          <button className="finance-blogs-section2-button">Contact Us</button>
        </div>
      </div>
      <div className="section3-card">
        <div className="finance-blogs-section3">
          <img
            className="finance-blogs-section3-img"
            src="../assets/img/finance/blog-two-image1.jpg"
            alt=""
          />
          <div className="finance-blogs-section3-comment">
            <p>
              <span class="material-symbols-outlined">manage_accounts</span> By
              Admin
            </p>
            <p>
              <span class="material-symbols-outlined">forum</span> Comments(05)
            </p>
          </div>
          <h3 className="finance-blogs-section3-heading">
            We Focus On The Solutions Not On The Problems
          </h3>
          <button className="finance-blogs-section3-button">
            Read More{" "}
            <span class="material-symbols-outlined">arrow_forward</span>
          </button>
        </div>
        <div className="finance-blogs-section3">
          <img
            className="finance-blogs-section3-img"
            src="../assets/img/finance/blog-two-image2.jpg"
            alt=""
          />
          <div className="finance-blogs-section3-comment">
            <p>
              <span class="material-symbols-outlined">manage_accounts</span> By
              Admin
            </p>
            <p>
              <span class="material-symbols-outlined">forum</span> Comments(05)
            </p>
          </div>
          <h3 className="finance-blogs-section3-heading">
            How to Create Viral Content That Drives Sales
          </h3>
          <button className="finance-blogs-section3-button">
            Read More{" "}
            <span class="material-symbols-outlined">arrow_forward</span>
          </button>
        </div>
        <div className="finance-blogs-section3">
          <img
            className="finance-blogs-section3-img"
            src="../assets/img/finance/blog-two-image3.jpg"
            alt=""
          />
          <div className="finance-blogs-section3-comment">
            <p>
              <span class="material-symbols-outlined">manage_accounts</span> By
              Admin
            </p>
            <p>
              <span class="material-symbols-outlined">forum</span> Comments(05)
            </p>
          </div>
          <h3 className="finance-blogs-section3-heading">
            How AI is Changing The Future of Online Shopping
          </h3>
          <button className="finance-blogs-section3-button">
            Read More{" "}
            <span class="material-symbols-outlined">arrow_forward</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinanceBlogs;
